/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_ACK_STATUS } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateAckMethods extends IPluginMethodMap {
  getUpdateAckStatus(args: any): Promise<any>;
}

export interface UpdateStatusProps {
  id: string;
}

export class UpdateAckService implements IAgentPlugin {
  readonly methods: IUpdateAckMethods;

  constructor() {
    this.methods = {
      getUpdateAckStatus: this.getUpdateAckStatus.bind(this),
    };
  }

  async getUpdateAckStatus(args: UpdateStatusProps) {
    console.log("args in service", args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_ACK_STATUS,
          variables: {
            payoutIds: args,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.acknowledgePayout) {
          return res?.data?.acknowledgePayout;
        }
      }
    } catch (err: any) {
      // console.log("error in revoke credential", err?.message);
      throw err;
    }
  }
}
